import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Bookmark20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.25 2.75V16.8278L9.47618 14.4157C9.80855 14.2623 10.1915 14.2623 10.5238 14.4157L15.75 16.8278V2.75H4.25ZM2.75 2.5C2.75 1.80964 3.30965 1.25 4 1.25H16C16.6904 1.25 17.25 1.80964 17.25 2.5V17.2185C17.25 18.1308 16.3045 18.7358 15.4762 18.3535L10 15.826L4.52382 18.3535C3.69555 18.7358 2.75 18.1308 2.75 17.2185V2.5Z'
      fill='currentColor'
    />
  </Svg>
);

Bookmark20.displayName = 'Bookmark20';
export default Bookmark20;
